const events: { [key: string]: string } = {
    onCopy: "copy",
    onCopyCapture: "copycapture",
    onCut: "cut",
    onCutCapture: "cutcapture",
    onPaste: "paste",
    onPasteCapture: "pastecapture",

// Composition Events
    onCompositionEnd: "compositionend",
    onCompositionEndCapture: "compositionendcapture",
    onCompositionStart: "compositionstart",
    onCompositionStartCapture: "compositionstartcapture",
    onCompositionUpdate: "compositionupdate",
    onCompositionUpdateCapture: "compositionupdatecapture",

// Focus Events
    onFocus: "focus",
    onFocusCapture: "focuscapture",
    onBlur: "blur",
    onBlurCapture: "blurcapture",

// Form Events
    onChange: "change",
    onChangeCapture: "changecapture",
    onBeforeInput: "beforeinput",
    onBeforeInputCapture: "beforeinputcapture",
    onInput: "input",
    onInputCapture: "inputcapture",
    onReset: "reset",
    onResetCapture: "resetcapture",
    onSubmit: "submit",
    onSubmitCapture: "submitcapture",
    onInvalid: "invalid",
    onInvalidCapture: "invalidcapture",

// Image Events
    onLoad: "load",
    onLoadCapture: "loadcapture",
    onError: "error", // also a Media Event
    onErrorCapture: "errorcapture", // also a Media Event

// Keyboard Events
    onKeyDown: "keydown",
    onKeyDownCapture: "keydowncapture",
    onKeyPress: "keypress",
    onKeyPressCapture: "keypresscapture",
    onKeyUp: "keyup",
    onKeyUpCapture: "keyupcapture",

// Media Events
    onAbort: "abort",
    onAbortCapture: "abortcapture",
    onCanPlay: "canplay",
    onCanPlayCapture: "canplaycapture",
    onCanPlayThrough: "canplaythrough",
    onCanPlayThroughCapture: "canplaythroughcapture",
    onDurationChange: "durationchange",
    onDurationChangeCapture: "durationchangecapture",
    onEmptied: "emptied",
    onEmptiedCapture: "emptiedcapture",
    onEncrypted: "encrypted",
    onEncryptedCapture: "encryptedcapture",
    onEnded: "ended",
    onEndedCapture: "endedcapture",
    onLoadedData: "loadeddata",
    onLoadedDataCapture: "loadeddatacapture",
    onLoadedMetadata: "loadedmetadata",
    onLoadedMetadataCapture: "loadedmetadatacapture",
    onLoadStart: "loadstart",
    onLoadStartCapture: "loadstartcapture",
    onPause: "pause",
    onPauseCapture: "pausecapture",
    onPlay: "play",
    onPlayCapture: "playcapture",
    onPlaying: "playing",
    onPlayingCapture: "playingcapture",
    onProgress: "progress",
    onProgressCapture: "progresscapture",
    onRateChange: "ratechange",
    onRateChangeCapture: "ratechangecapture",
    onSeeked: "seeked",
    onSeekedCapture: "seekedcapture",
    onSeeking: "seeking",
    onSeekingCapture: "seekingcapture",
    onStalled: "stalled",
    onStalledCapture: "stalledcapture",
    onSuspend: "suspend",
    onSuspendCapture: "suspendcapture",
    onTimeUpdate: "timeupdate",
    onTimeUpdateCapture: "timeupdatecapture",
    onVolumeChange: "volumechange",
    onVolumeChangeCapture: "volumechangecapture",
    onWaiting: "waiting",
    onWaitingCapture: "waitingcapture",

// MouseEvents
    onAuxClick: "auxclick",
    onAuxClickCapture: "auxclickcapture",
    onClick: "click",
    onClickCapture: "clickcapture",
    onContextMenu: "contextmenu",
    onContextMenuCapture: "contextmenucapture",
    onDoubleClick: "doubleclick",
    onDoubleClickCapture: "doubleclickcapture",
    onDrag: "drag",
    onDragCapture: "dragcapture",
    onDragEnd: "dragend",
    onDragEndCapture: "dragendcapture",
    onDragEnter: "dragenter",
    onDragEnterCapture: "dragentercapture",
    onDragExit: "dragexit",
    onDragExitCapture: "dragexitcapture",
    onDragLeave: "dragleave",
    onDragLeaveCapture: "dragleavecapture",
    onDragOver: "dragover",
    onDragOverCapture: "dragovercapture",
    onDragStart: "dragstart",
    onDragStartCapture: "dragstartcapture",
    onDrop: "drop",
    onDropCapture: "dropcapture",
    onMouseDown: "mousedown",
    onMouseDownCapture: "mousedowncapture",
    onMouseEnter: "mouseenter",
    onMouseLeave: "mouseleave",
    onMouseMove: "mousemove",
    onMouseMoveCapture: "mousemovecapture",
    onMouseOut: "mouseout",
    onMouseOutCapture: "mouseoutcapture",
    onMouseOver: "mouseover",
    onMouseOverCapture: "mouseovercapture",
    onMouseUp: "mouseup",
    onMouseUpCapture: "mouseupcapture",

// Selection Events
    onSelect: "select",
    onSelectCapture: "selectcapture",

// Touch Events
    onTouchCancel: "touchcancel",
    onTouchCancelCapture: "touchcancelcapture",
    onTouchEnd: "touchend",
    onTouchEndCapture: "touchendcapture",
    onTouchMove: "touchmove",
    onTouchMoveCapture: "touchmovecapture",
    onTouchStart: "touchstart",
    onTouchStartCapture: "touchstartcapture",

// Pointer Events
    onPointerDown: "pointerdown",
    onPointerDownCapture: "pointerdowncapture",
    onPointerMove: "pointermove",
    onPointerMoveCapture: "pointermovecapture",
    onPointerUp: "pointerup",
    onPointerUpCapture: "pointerupcapture",
    onPointerCancel: "pointercancel",
    onPointerCancelCapture: "pointercancelcapture",
    onPointerEnter: "pointerenter",
    onPointerEnterCapture: "pointerentercapture",
    onPointerLeave: "pointerleave",
    onPointerLeaveCapture: "pointerleavecapture",
    onPointerOver: "pointerover",
    onPointerOverCapture: "pointerovercapture",
    onPointerOut: "pointerout",
    onPointerOutCapture: "pointeroutcapture",
    onGotPointerCapture: "gotpointercapture",
    onGotPointerCaptureCapture: "gotpointercapturecapture",
    onLostPointerCapture: "lostpointercapture",
    onLostPointerCaptureCapture: "lostpointercapturecapture",

// UI Events
    onScroll: "scroll",
    onScrollCapture: "scrollcapture",

// Wheel Events
    onWheel: "wheel",
    onWheelCapture: "wheelcapture",

// Animation Events
    onAnimationStart: "animationstart",
    onAnimationStartCapture: "animationstartcapture",
    onAnimationEnd: "animationend",
    onAnimationEndCapture: "animationendcapture",
    onAnimationIteration: "animationiteration",
    onAnimationIterationCapture: "animationiterationcapture",

// Transition Events
    onTransitionEnd: "transitionend",
    onTransitionEndCapture: "transitionendcapture",
};

export default function getAttrEventType(attr: string) {
    if(events[attr]){
        return events[attr];
    }
    return null;
}